module.exports = __webpack_public_path__ + "img/store-new.49c2ac05.svg";